module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("You Might Get Eaten")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('strong', [_vm._v("DAMN. HE ALWAYS FORGOT ABOUT")]), _vm._v(" that chunk of broken pavement. Ed Fargo swore under his breath and gave a sharp jerk to his wheels. He pulled himself out of the rut, then rolled around the corner of Perry Street toward Gaia’s brownstone. His breath puffed out in the frigid air. January in New York was as dismal as things get.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Ed took in the scene around him. The ugly stamp of humanity’s feet had already taken its toll on the winter streets. Pristine white snow was now sullen brown slush. Plowed drifts covered corners and curbs, creating treacherous mounds of filthy, spit-upon, dog-pissed-upon ice. Try getting a wheelchair through it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gotta get snow tires,” Ed muttered. As he made his way up Perry Street, a memory suddenly clamped over his heart, making him clench his wheels tighter, blow harder as he breathed. For a few moments he’d been distracted from the memory by other things. For a few moments he’d forgotten about Mary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mary was dead.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Part of him still couldn’t quite take it in. Didn’t want to. For the past month he and Mary and Gaia had been a real threesome. They had hung out, ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("partied, talked. … It was the only time Ed had been with people he considered friends since, well, since the accident. "), _c('em', [_vm._v("True")]), _vm._v(" friends.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Sure, separate, Mary and Gaia had both been pretty intense. Together the two of them had been compelling, exciting … and infuriating. Like when Mary had dared Gaia to make out with Ed just a few nights ago. Given Ed’s deeply felt but hidden lust for Gaia, that had been pretty wild. Weird, but wild.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ed paused and rubbed his chin in the twenty-five-degree air. He realized he’d been smiling. Again he’d forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mary was dead, killed the night before last in the park. To Ed, it looked like a years-long major coke addiction had finally caught up to her. She’d died with drugs in her possession. Gaia had been there, speaking to the cops, when Ed had arrived. Too late. He was always too late.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Oh, Mary.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("True, once or twice Ed had resented how close Mary and Gaia were becoming. But Mary had been Ed’s friend, too. She’d been fun, beautiful, full of enthusiasm and life and humor and outrageousness. She’d been too young to die.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Ed rolled to a stop before Gaia’s brownstone. He swallowed, hard. It was freezing out "), _c('em', [_vm._v("here")]), _vm._v(". What would he find in "), _c('em', [_vm._v("there?")]), _vm._v(" He reached toward the doorbell, thought better of it, and pulled back his hand to fiddle ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("with the armrest of his chair, his heart pounding.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Why was this so hard?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During this last month Ed had seen Gaia unbend more, smile more, laugh more, show her soft side more than in the whole time he’d known her. It had been due to Mary. Now Mary was wearing a toe tag. How was Gaia going to react? What’s more, how was Ed going to make it easier for her to deal? Gaia had refused to come to the door or talk on the phone all day yesterday. Who was to say she would even let Ed say two words to her today?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ed’s watch said eight-twelve. The Village School was opening its battered wood-and-metal doors right now. Thanks to a bunch of snow days, they’d been gypped on winter vacation and had to go back to school early. But there was no doubt Gaia would skip today. Maybe George or Ella had already called her in sick.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The thought of Gaia spending yesterday with just her clueless foster father or bitchy foster mother to console her literally made Ed’s stomach turn. Today he wanted to be the one who was there for her, to hold her as she cried, to comfort her as well as he could. Now he would have a chance to protect her, just like she’d always protected him. Maybe it would even be a chance for Gaia and Ed to get closer. Maybe he would be able to tell her he loved her. That he wanted to be with her. Yeah, in "), _c('em', [_vm._v("that")]), _vm._v(" way.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Ed took a deep breath and tried to clear his head. ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Just as his gloved index finger reached out to the bell, the heavy front door opened. Gaia came out.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In a frozen moment Ed searched her face. Gaia looked pale but otherwise … fine. Calm. Kind of … "), _c('em', [_vm._v("normal")]), _vm._v(". No tearstained cheeks, no swollen eyes, no pain etched on her face. She was dressed for school in an ancient pair of jeans that looked like they had been rescued from a tribe of renegade dust bunnies hiding under her bed. A pale blue, stretched-out turtleneck collar showed at the opening of a worn, electric blue, puffy down ski jacket. The jacket had a hole in it, and feathers were leaking out. Her glorious blond hair hung in wet, ratlike clumps around her head. Ed knew it would be frozen solid before she reached the end of the block. Same old Gaia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” Gaia said calmly, tucking some wet hair behind one ear. She hitched her messenger bag higher on her shoulder, strode past Ed, and headed down the block.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a moment Ed was too confused to do anything but stare after her. Mary was dead, right? He hadn’t just dreamed it. His wheels spun as he caught up to her. “You’re going to school?” he asked, hating how his voice sounded—flabbergasted, childish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia glanced down at him blankly. “It "), _c('em', [_vm._v("is")]), _vm._v(" a school day,” she pointed out. “Is there some holiday I don’t know about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But—” Ed bumped over a curb that the universal handicapped accessibility codes hadn’t caught up with yet.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("“But what?” Gaia asked. They swung around a corner as Ed struggled to organize his thoughts into some kind of a coherent sentence.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you might stay home today,” he said carefully as he caught up to her. "), _c('em', [_vm._v("Great. Great sentence. You’re a genius, Ed.")]), _vm._v(" “I thought you might be upset.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia sniffed and wiped the back of her hand across her nose as he stared up at her expectantly. “What is it with cold air and "), _c('em', [_vm._v("snot?")]), _vm._v("” she asked, just as the light turned green. Ed stopped dead in his tracks. He had to say something, "), _c('em', [_vm._v("anything,")]), _vm._v(" that would help him connect with her. He braced himself, waiting for Gaia to realize he’d stopped and turn around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Gaia "), _c('em', [_vm._v("didn’t")]), _vm._v(" stop. She crossed the street and just kept going, never once looking back. Ed’s mouth worked open and closed, but nothing came out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a matter of seconds she was out of sight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ed just stared after her.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c1b682c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 84
// module chunks = 0